import AngularTemplate from './components/AngularTemplate';

export default AngularTemplate;
